module.exports = __webpack_public_path__ + "media/src/img/payment/alfabank-logo-7323884e42cb2452c4e3d68251076713.svg";